import { memo } from 'react'
import { divideTextFromVariable } from 'utils'
import { DROPDOWN_NO_RESULTS_PNG } from 'consts/images'
import Text from '../Text'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import * as Styled from './styled'

interface IProps {
  searchValue: string
  className?: string
  imgSrc?: string
}

const SearchNoResult: React.FC<IProps> = props => {
  const { searchValue, className, imgSrc = DROPDOWN_NO_RESULTS_PNG } = props
  const { beforeSearchValuePart, afterSearchValuePart } =
    divideTextFromVariable(translate(T.NO_SEARCH_RESULT_DESCRIPTION))

  return (
    <Styled.SearchNoResultContainer className={className}>
      <Styled.SearchNoResultImage src={imgSrc} />

      <Styled.SearchNoResultTextsWrapper>
        <Text color={'secondarySemiDark'} type="h4">
          {beforeSearchValuePart}
        </Text>
        {searchValue && (
          <Text type="h4" color={'secondarySemiDark'} ellipsis fontWeight="600">
            &quot;{searchValue}&quot;
          </Text>
        )}
        <Text color={'secondarySemiDark'} type="h4">
          {afterSearchValuePart}
        </Text>
      </Styled.SearchNoResultTextsWrapper>
    </Styled.SearchNoResultContainer>
  )
}

export default memo(SearchNoResult)
